export const isNeededResetDataSearch = (prevSearchTerm, nextSearchTerm) =>
  (nextSearchTerm.length > 1 && prevSearchTerm.length < nextSearchTerm.length)
  || (prevSearchTerm.length > 1 && nextSearchTerm.length < prevSearchTerm.length);



// WEBPACK FOOTER //
// ./src/utils/search.js